import { computed, inject, ref } from "vue";
export const SpinnerSymbol = Symbol();
export const SpinnerService = {
    install: (app) => {
        const visible = ref(false);
        const show = () => {
            visible.value = true;
        };
        const hide = () => {
            visible.value = false;
        };
        const isVisible = computed(() => visible);
        app.provide(SpinnerSymbol, { isVisible, show, hide });
        app.config.globalProperties.$showSpinner = show;
        app.config.globalProperties.$hideSpinner = hide;
    }
};
export function useSpinner() {
    const spinner = inject(SpinnerSymbol);
    if (!spinner) {
        throw new Error(`Could not resolve ${SpinnerSymbol.description}`);
    }
    return spinner;
}
